function initPageTarifV2() {
	if (!document.body.classList.contains("page-template-template-tarif-v2")) {
		return;
	}

	const horsParis = document.querySelector(".toggle-container .outside-paris");
	if (horsParis) {
		const paris = document.querySelector(".toggle-container .paris");
		const contentHorsParis = document.querySelector(`.inner-location[data-location="outside_paris"]`);
		const contentParis = document.querySelector(`.inner-location[data-location="paris"]`);

		horsParis.addEventListener("click", () => {
			if (!horsParis.classList.contains("active")) {
				horsParis.classList.add("active");
				paris.classList.remove("active");
				contentHorsParis.classList.add("active");
				contentParis.classList.remove("active");
				pageTarifV2Resize();
			}
		});

		paris.addEventListener("click", () => {
			if (!paris.classList.contains("active")) {
				paris.classList.add("active");
				horsParis.classList.remove("active");
				contentHorsParis.classList.remove("active");
				contentParis.classList.add("active");
				pageTarifV2Resize();
			}
		});
	}

	const bannerInfo = document.querySelector(".banner-info-inner");
	const bannerPrices = document.querySelector(".banner-title-container");
	pageTarifV2Resize();


	function pageTarifV2Resize() {
		if (window.innerWidth > 992) {
			bannerPrices.style.height = bannerInfo.clientHeight + 30 + "px";
		} else {
			bannerPrices.style.height = "auto";
		}
	}

	window.addEventListener("resize", () => {
		pageTarifV2Resize();
	});

	const vimeoPopup = document.querySelector("#vimeoPopup");
	const iframeContainer = vimeoPopup.querySelector(".iframe-container");
	if (vimeoPopup) {

		document.querySelectorAll(`[data-open-vimeo]`).forEach(elem => {
			let url = elem.dataset.openVimeo;
			if (url) {
				elem.addEventListener("click", () => {
					iframeContainer.setAttribute("id", elem.dataset.openVimeoId);
					window.currentVimeoId = elem.dataset.openVimeoId;
					vimeoPopup.classList.add("active");
					LoadScript.load('https://player.vimeo.com/api/player.js', playThisClassicVimeoVideo);


				});
			}
		});

		document.querySelectorAll("#vimeoPopup .background, #vimeoPopup .close").forEach(elem => {
			elem.addEventListener("click", () => {
				vimeoPopup.classList.remove("active");
				window.playerVimeo.pause();
			});
		});
	}

	function playThisClassicVimeoVideo() {
		if (window.playerVimeo) {
			window.playerVimeo.loadVideo(window.currentVimeoId).catch(error => console.error("Erreur lors du chargement de la vidéo :", error));
		} else {
			window.playerVimeo = new Vimeo.Player(iframeContainer, {
				id: window.currentVimeoId,
				byline: false,
				autoplay: true,
				muted: document.documentElement.classList.contains("touchevents"),
				color: "d32d2a"
			});
			window.playerVimeo.on('ended', function () {
				vimeoPopup.classList.remove("active");
			});
		}
	}

	document.querySelectorAll(".inner-location").forEach(location => {
		const locationName = location.dataset.location;
		const offer1Radio = location.querySelector(`input#${locationName}_package1`);
		const offer2Radio = location.querySelector(`input#${locationName}_package2`);
		const offer3Radio = location.querySelector(`input#${locationName}_package3`);
		const button = location.querySelector("#packagesButton");
		if (offer1Radio) {
			offer1Radio.addEventListener("change", () => {
				button.setAttribute("href", button.dataset["offer-1Link"]);
				button.setAttribute("target", button.dataset["offer-1Target"]);
			});
		}

		if (offer2Radio) {
			offer2Radio.addEventListener("change", () => {
				button.setAttribute("href", button.dataset["offer-2Link"]);
				button.setAttribute("target", button.dataset["offer-2Target"]);
			});
		}

		if (offer3Radio) {
			offer3Radio.addEventListener("change", () => {
				button.setAttribute("href", button.dataset["offer-3Link"]);
				button.setAttribute("target", button.dataset["offer-3Target"]);
			});
		}

		const info = location.querySelectorAll(".packages-legals-container");
		info.forEach(elem => {
			const toggle = elem.querySelector(".packages-legals");

			toggle.addEventListener("click", () => {
				elem.classList.toggle("active");
				pageTarifV2Resize();
			});
		})
	});
}
